import React, { FC, useCallback, useMemo } from 'react';
import { Chip, IconButton, TableCell, TableRow } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { ArrowIcon, CustomTable } from '../../../../components';
import { Payments, PaymentStatus } from '../../CashbackModel';
import { useCommonStyles } from '../../../../styles';
import { formatDate, PATH_IB_CLIENTS_CASHBACK } from '../../../../utils';
import { useStyles } from './styles';

interface Props {
  translation: any;
  locale: string;
  payments: Payments[];
}

export const PaymentsTable: FC<Props> = ({ translation, payments, locale }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const columns = useMemo(() => [translation.text_841, translation.campaign, translation.text_266, translation.text_1188, translation.cashback, translation.text_6008], [translation]);

  const renderHeader = useMemo((): any[] => {
    const result: any[] = [];

    columns.forEach((columnName) => {
      result.push(
        <TableCell key={columnName} align="left">
          {columnName}
        </TableCell>,
      );
    });
    result.push(<TableCell>&nbsp;</TableCell>);
    return result;
  }, [columns]);

  const renderRows = useCallback((): any[] => {
    const result: any[] = [];
    payments.forEach((row) => {
      result.push(
        <TableRow className={commonClasses.tableRow} key={Math.random()}>
          <TableCell align="left">{`${formatDate(row.periodStart, locale)} - ${formatDate(row.periodEnd, locale)}`}</TableCell>
          <TableCell align="left">{row.campaignName}</TableCell>
          <TableCell align="left">{row.clientCount}</TableCell>
          <TableCell align="left">{`${row.commissionAmmount.toFixed(2)} USD`}</TableCell>
          <TableCell align="left">{`${row.cashbackAmount.toFixed(2)} USD`}</TableCell>
          <TableCell align="left">
            <Chip
              label={
                row.status === PaymentStatus[PaymentStatus.InProgress]
                  ? translation.text_864
                  : row.status === PaymentStatus[PaymentStatus.Pending]
                  ? translation.text_5723
                  : row.status === PaymentStatus[PaymentStatus.Failed]
                  ? translation.text_817
                  : row.status === PaymentStatus[PaymentStatus.Rejected]
                  ? translation.rejected
                  : row.status === PaymentStatus[PaymentStatus.Paid]
                  ? translation.paid
                  : translation.partially_paid
              }
              className={`${classes.status} ${
                row.status === PaymentStatus[PaymentStatus.Pending] || row.status === PaymentStatus[PaymentStatus.InProgress]
                  ? classes.pending
                  : row.status === PaymentStatus[PaymentStatus.Paid]
                  ? classes.paid
                  : row.status === PaymentStatus[PaymentStatus.Mixed]
                  ? classes.mixed
                  : classes.rejected
              }`}
            />
          </TableCell>
          <TableCell align="left">
            <IconButton component={Link} to={PATH_IB_CLIENTS_CASHBACK}>
              <ArrowIcon />
            </IconButton>
          </TableCell>
        </TableRow>,
      );
    });
    return result;
  }, [payments, commonClasses, translation, classes, locale]);

  return <CustomTable headerCells={renderHeader} rows={renderRows()} rowsCountNumber={4} columnsNumber={columns.length} emptyDataMessage={translation.there_are_no_payments} />;
};
